import React, { useEffect, useState, useCallback, useRef } from "react";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import API from "../../Api/api";
import paymentStyle from "../payment.module.css";
import Loader from "../loader";

export enum SUBSCRIPTION_ROUTES {
  REVIEW = "/review/subscription",
  THANKYOU = "/thankyou",
}

interface PaypalPaymentProps {
  subscriptionContentDetails:any
 
}

interface CreateOrderData {
  redirectUrl: string;
  transactionId: string;
}

const PaypalPayment: React.FC<PaypalPaymentProps> = ({
 
  subscriptionContentDetails,
}) => {
  const [initialOptions, setInitialOptions] = useState<any>(null);
  const [gatewayPublishableKey, setGatewayPublishableKey] = useState<
    string | null
  >(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [createOrderData, setCreateOrderData] =
    useState<CreateOrderData | null>(null);
  const isInitialized = useRef(false); // Track initialization



  const initializeCheckout = useCallback(async () => {
    if (!subscriptionContentDetails) {
      setError("Invalid subscription content details");
      setLoading(false);
      return;
    }

    const modifyRedirectUrl = new URL(
      subscriptionContentDetails.successFrontendUrl
    );
    modifyRedirectUrl.searchParams.append(
      "viewId",
      subscriptionContentDetails.viewId
    );
    modifyRedirectUrl.searchParams.append(
      "clientId",
      subscriptionContentDetails.clientId
    );
    modifyRedirectUrl.searchParams.append(
      "clientContentId",
      subscriptionContentDetails.clientContentId
    );

    subscriptionContentDetails.redirectUrl = modifyRedirectUrl.toString();
    subscriptionContentDetails.successFrontendUrl =
      modifyRedirectUrl.toString();

    const postRenewalPrams = {
      clientId: subscriptionContentDetails.clientId,
      subscriptionId: subscriptionContentDetails.subscriptionId,
      tierId: subscriptionContentDetails.tierId,
      type: "SUBSCRIPTION",
      contentDetails: subscriptionContentDetails,
      couponCode: subscriptionContentDetails.couponCode,
      consumeFreeTrial: subscriptionContentDetails.consumeFreeTrial,
      anonId: subscriptionContentDetails.anonId,
      redirectUrl: subscriptionContentDetails.redirectUrl,
      successFrontendUrl: subscriptionContentDetails.successFrontendUrl,
      amount: subscriptionContentDetails.amount,
      currency: subscriptionContentDetails.currency,
      numberOfLicense: subscriptionContentDetails.numberOfLicense,
    };

    try {
      let paypalOrderResponse;
      if (subscriptionContentDetails.renewSubscription) {
        paypalOrderResponse = await API.payment.PaypalOrderForRenewal({
          callPaypalPrams: postRenewalPrams,
        });
      } else {
        paypalOrderResponse = await API.payment.CallPaypal({
          callPaypalPrams: subscriptionContentDetails,
        });
      }

      if (!API.validators.checkSuccessCode(paypalOrderResponse)) {
        throw new Error("Unable to create PayPal order");
      }

      const { paypalRedirectUrl, transactionId, publishableKey } =
        paypalOrderResponse.data.data;
      setGatewayPublishableKey(publishableKey);
      setCreateOrderData({ redirectUrl: paypalRedirectUrl, transactionId });
      window.location.href = paypalRedirectUrl;
    } catch (err) {
      console.error("Error creating PayPal order:", err);
      setError("Error creating PayPal order");
      setLoading(false);
    }
  }, [ subscriptionContentDetails]);

  useEffect(() => {
    if (!isInitialized.current ) {
      initializeCheckout();
      isInitialized.current = true; // Mark as initialized
    }
  }, [ initializeCheckout]);

  useEffect(() => {
    if (gatewayPublishableKey) {
      setInitialOptions({ "client-id": gatewayPublishableKey });
    }
  }, [gatewayPublishableKey]);

  return (
    <>
      {initialOptions ? (
        <PayPalScriptProvider options={initialOptions}>
          <div className={paymentStyle["main-container"]}>
            {loading && <Loader />}
            {error && (
              <div className={paymentStyle["error-message"]}>{error}</div>
            )}
          </div>
        </PayPalScriptProvider>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default PaypalPayment;
